export const CHART_PRINT_ID = 'cost-savings-chart-id'

export enum DYNAMIC_EMS_SOFTWARE_REQUIREMENT {
  MinimumYear = '2025',
  MinimumMonth = '02',
}

export enum DYNAMIC_EMS_V2_SOFTWARE_REQUIREMENT {
  MinimumYear = '2025',
  MinimumMonth = '60',
}

export enum YAxisDomainConfig {
  BoundaryFactor = 0.2,
  BoundaryMinimum = 1,
  TickCount = 5,
}
